var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { domainService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject } from "~/core/decorator";
import { FilterService } from '~/utils/filter.service';
var OutsourceStayService = /** @class */ (function () {
    function OutsourceStayService() {
    }
    /**
     * 分案确认
     */
    OutsourceStayService.prototype.confirmDistributeCase = function (data) {
        return this.netService.send({
            server: domainService.outsourceStayManageController.confirmDistributeCase,
            data: data
        });
    };
    /**
     * 委外方列表
     */
    OutsourceStayService.prototype.searchOutsourcePreview = function (isLawsuit, page) {
        return this.netService.send({
            server: domainService.outsourceStayManageController.searchOutsourcePreview,
            page: page,
            data: {
                isLawsuit: isLawsuit
            }
        });
    };
    /**
     * 待分配列表
     */
    OutsourceStayService.prototype.searchPendingList = function (data, page, sort) {
        return this.netService.send({
            server: domainService.outsourceStayManageController.searchPendingList,
            data: {
                overdueAmountStart: data.outAmount ? data.outAmount.min : '',
                overdueAmountEnd: data.outAmount ? data.outAmount.max : '',
                overdueDaysStart: data.overdueDays ? data.overdueDays.min : '',
                overdueDaysEnd: data.overdueDays ? data.overdueDays.max : '',
                followInTimeStart: FilterService.dateRanageFormat(data.followInTime).start,
                followInTimeEnd: FilterService.dateRanageFormat(data.followInTime).end,
                area: data.area,
                personalName: data.personalName,
                turnSource: data.turnSource,
                productName: data.productName,
                productCategory: data.productCategory,
                overduePeriod: data.overduePeriod,
                outAmount: data.outAmount,
                mobileNo: data.mobileNo,
                localAddress: data.localAddress,
                idCard: data.idCard,
                currentCollector: data.currentCollector,
                batchNumber: data.batchNumber,
                caseNumber: data.caseNumber,
                cityCode: data.cityCode,
                followupBack: data.followupBack,
                outSourceType: data.outSourceType,
                labelName: data.labelName,
                caseMoneyMin: data.caseMoney ? data.caseMoney.min : '',
                caseMoneyMax: data.caseMoney ? data.caseMoney.max : '',
            },
            page: page,
            sort: sort,
        });
    };
    /**
     * 分案预览列表
     */
    OutsourceStayService.prototype.searchSplitPreview = function (data) {
        return this.netService.send({
            server: domainService.outsourceStayManageController.searchSplitPreview,
            data: data
        });
    };
    __decorate([
        Inject(NetService)
    ], OutsourceStayService.prototype, "netService", void 0);
    return OutsourceStayService;
}());
export { OutsourceStayService };
